import React from 'react';

import * as ST from './styled';

export interface IAdvantage {
    id: number | string,
    icon: string,
    title: string,
    alt?: string,
}

interface IProps {
    items: IAdvantage[],
    className?: string,
}

const Advantages: React.FC<IProps> = ({ items = [], className = '' }): JSX.Element => {
    return (<ST.Wrapper className={className}>
        {
            items?.map((item) => {
                return (<ST.AdvantageItem key={item.id} data-test='advantage-item'>
                    <ST.Icon src={item.icon} alt={item.alt} data-test='advantage-item-icon'/>
                    <ST.Title data-test='advantage-item-title'>{item.title}</ST.Title>
                </ST.AdvantageItem>);
            })
        }
    </ST.Wrapper>);
};

export default Advantages;
